var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "kxd-map-container",
      staticClass: "kxd-map-container",
      style: _vm.css_props
    },
    [
      _c("section", { staticClass: "map-ctrl map-left-top-ctrl" }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "map-ctrl map-left-bottom-ctrl" },
        [
          _vm._l(_vm.colorbars, function(options) {
            return _c("colorbar", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.check_in_maptool_colorbars_list(options.name),
                  expression: "check_in_maptool_colorbars_list(options.name)"
                }
              ],
              key: options.name,
              ref: "colorbar-" + options.name,
              refInFor: true,
              class: "colorbar-container",
              attrs: { options: options, draggable: true }
            })
          }),
          _vm._v(" "),
          Object.keys(_vm.max_rain).length > 0 &&
          _vm.check_in_maptool_colorbars_list(_vm.max_rain.id)
            ? _c(
                "div",
                {
                  directives: [{ name: "draggable", rawName: "v-draggable" }],
                  staticClass: "max-rain-colorbar__container"
                },
                [_c("img", { attrs: { src: _vm.max_rain.src, width: "100%" } })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("cursor-latlng", {
            style: _vm.according_popup_table,
            attrs: {
              id: "cursor_latlng_container",
              lat: _vm.cursor_latlng.lat,
              lng: _vm.cursor_latlng.lng,
              map: _vm.map
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "map-ctrl map-right-top-ctrl" },
        [
          _vm._l(_vm.panes_tag, function(options, key) {
            return _c("pane-tag", {
              key: key,
              class: "map-top-item",
              attrs: { options: options }
            })
          }),
          _vm._v(" "),
          _c("pane-tag-case", { class: "map-top-item" })
        ],
        2
      ),
      _vm._v(" "),
      _c("section", { staticClass: "map-ctrl map-right-bottom-ctrl" }, [
        _c("div", { staticClass: "capture-img__container" }, [
          _c("img", {
            staticClass: "capture-img",
            attrs: {
              src: "/static/images/capture/white_cwa_logo_string_eng.png",
              width: "100%"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "capture-img__description" },
            [
              _vm.accumulated_precp.start_time && _vm.accumulated_precp.end_time
                ? [
                    _c("div", [_vm._v("累積雨量查詢時間:")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.accumulated_precp.start_time) +
                          " ~ " +
                          _vm._s(_vm.accumulated_precp.end_time)
                      )
                    ])
                  ]
                : _c("span", [_vm._v(_vm._s(_vm.capture_datetime_description))])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "map-ctrl map-top-right-ctrl" },
        [
          _vm.client_name !== "pub" && _vm.is_show_favorites
            ? _c("favorites-btn", {
                ref: "favorites_btn",
                on: {
                  change_favorites_hint_text: _vm.change_favorites_hint_text
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("product-setting-btn", {
            ref: "product_setting_btn",
            attrs: { is_show_favorites: _vm.is_show_favorites },
            on: {
              "open-product-setting-dialog": _vm.open_product_setting_dialog
            }
          }),
          _vm._v(" "),
          _c("map-btn-tool", {
            attrs: {
              id: "map_btn_tool_container",
              config: _vm.config.map,
              map_zoom: _vm.zoom,
              opacity_tool: _vm.panes_opacity,
              order_tool: _vm.panes_order
            },
            on: {
              zoom_in: _vm.zoom_in,
              zoom_out: _vm.zoom_out,
              fit_bounds: _vm.fit_bounds,
              set_map_view: _vm.set_map_view,
              change_basemap: _vm.change_basemap,
              toggle_boundary: _vm.toggle_boundary,
              toggle_measure_tool: _vm.toggle_measure_tool,
              capture: _vm.capture
            }
          }),
          _vm._v(" "),
          _c("measure-tool", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.measure_tool.status,
                expression: "measure_tool.status"
              }
            ],
            class: "map-item-style map-shadow map-top-item",
            attrs: {
              id: "measure_tool_container",
              cursor_latlng: _vm.cursor_latlng,
              tool: _vm.measure_tool
            },
            on: { create_layer: _vm.create_layer, clear_pane: _vm.clear_pane }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.product_setting_tool.status,
                  expression: "product_setting_tool.status"
                }
              ],
              staticClass: "map-root-item"
            },
            [
              _c("product-setting-items", {
                attrs: {
                  panes: _vm.panes,
                  panes_tag: _vm.panes_tag,
                  opacity_tool: _vm.panes_opacity,
                  order_tool: _vm.panes_order,
                  all_map_config: _vm.config,
                  props_zoom_level: _vm.zoom
                },
                on: {
                  change_visibility: _vm.change_visibility,
                  change_order: _vm.change_order,
                  change_opacity: _vm.change_opacity_by_user,
                  "change-zoom": _vm.change_zoom,
                  "close-product-setting-dialog":
                    _vm.close_product_setting_dialog
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        ref: "kxd-map",
        staticClass: "kxd-map",
        attrs: { zoom: _vm.zoom }
      }),
      _vm._v(" "),
      _vm._l(_vm.kxd_renders, function(options, key) {
        return _c("kxd-render", {
          key: options.key,
          attrs: {
            name: key,
            text: _vm.panes_config[key].text,
            options: options,
            pane: _vm.panes[key],
            cursor_latlng: _vm.cursor_latlng,
            colorbar: _vm.$refs["colorbar-" + key]
          },
          on: { create_colorbar: _vm.create_colorbar }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.kxd_renders_v2, function(options, key) {
        return _c("kxd-render-v2", {
          key: options.key,
          attrs: {
            name: key,
            text: _vm.panes_config[key].text,
            options: options,
            pane: _vm.panes[key],
            cursor_latlng: _vm.cursor_latlng,
            colorbar: _vm.$refs["colorbar-" + key]
          },
          on: { create_colorbar: _vm.create_colorbar }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.wmarkers, function(options, key) {
        return _c("w-marker", {
          key: options.key,
          attrs: {
            name: key,
            options: options,
            pane: _vm.panes[key],
            zoom: _vm.zoom
          }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.nineblock_items, function(options, pane_name) {
        return _c("nine-block", {
          key: _vm.nineblock_items_key + "_" + pane_name,
          attrs: {
            name: pane_name,
            options: options,
            pane: _vm.panes[pane_name]
          }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.measure_items, function(item, key) {
        return _c("measure-item", {
          key: key,
          attrs: { options: item, measure_tool: _vm.measure_tool }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }